import { Injectable } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { Observable, ReplaySubject } from "rxjs";
import { map, shareReplay, tap, filter } from 'rxjs/operators';
import { RolePermission } from "src/app/models/user-profile/UserProfile.model";
import { AppState, loginUserProfile } from "src/app/store/reducers";

@Injectable({
  providedIn: "root",
})
export class RolePermissionsService {
  private roles$: Observable<RolePermission[]>;
  private rolesSnapshot: RolePermission[] = [];

  constructor(private store: Store<AppState>) {
    this.roles$ = this.store.pipe(
      select(loginUserProfile),
      filter(user => !!user),
      map((user) => user?.profileRoles ?? []),
      tap((roles) => {
        this.rolesSnapshot = roles;
      }),
      shareReplay(1)
    );
  }

  hasPermission(roleCode: string, permissionCode: string): Observable<boolean> {
    return this.roles$.pipe(
      map((roles) => this.checkPermission(roles, roleCode, permissionCode))
    );
  }

  hasPermissionSync(roleCode: string, permissionCode: string): boolean {
    return this.checkPermission(this.rolesSnapshot, roleCode, permissionCode);
  }

  private checkPermission(roles: RolePermission[], roleCode: string, permissionCode: string): boolean {
    return roles.some(
      (role) =>
        role.role.code === roleCode &&
        role.permissions.some((p) => p.code === permissionCode)
    );
  }
}